<template>
  <div class="dashboard-stats">
    <div class="ms-container-header">
      <icon size="16" type="md-stats" />
      Статистика
    </div>
    <div class="dashboard-stats__container">
      <alert type="info">Всего задач: {{ all }}</alert>
      <alert type="error">Просрочено: {{ expired }}</alert>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    all () {
      return this.$store.state.dashboard.allTasksCount
    },
    expired () {
      return this.$store.state.dashboard.expiredTasksCount
    }
  }
}
</script>

<style lang="less">
.dashboard-stats {
  margin-bottom: 16px;

  &__container {
    display: flex;
    align-items: center;

    .ivu-alert {
      flex: 1;
      margin-bottom: 0;

      &:not(:first-child) {
        margin-left: 16px;
      }
    }
  }
}
</style>
